<script>
import { clienteComputed } from "@/state/helpers";

/**
 * Envoltura de las vistas de "Mi empresa".
 *
 * El único requisito del área es ser de tipo comercio. Administrar el propio
 * negocio —y publicar eventos y vacantes— no exige membresía vigente: el muro
 * de pago cubre lo que el comercio *consume* (Sesiones y el directorio), no lo
 * que *aporta*, porque cuanto más publiquen los comercios más valor tiene la
 * red para todos.
 *
 * Repetir esta comprobación en cada vista invitaba a que una se quedara sin
 * ella; aquí se escribe una vez.
 */
export default {
  computed: {
    ...clienteComputed,
    resolviendo() {
      // Mientras se carga el perfil no se puede afirmar nada: mostrar el aviso
      // de "no eres comercio" a un comercio sería un falso negativo.
      return this.cargandoCliente || !this.perfilCliente;
    },
  },
};
</script>

<template>
  <div>
    <p v-if="resolviendo" class="text-muted">Cargando…</p>

    <div v-else-if="!esComercio" class="aviso-card text-center">
      <i class="mdi mdi-storefront-outline aviso-icono"></i>
      <h2 class="h5 mt-3">Esta sección es para comercios</h2>
      <p class="text-muted mb-0">
        Tu cuenta está registrada como usuario. Si tienes un negocio y quieres publicarlo en
        Recnet, date de alta como comercio desde la app.
      </p>
    </div>

    <slot v-else />
  </div>
</template>

<style scoped>
.aviso-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 48px 24px;
  max-width: 560px;
  margin: 32px auto;
}

.aviso-icono {
  font-size: 56px;
  color: #adb5bd;
}
</style>
